export const contentTableConfig = {
  title: '用户列表',
  propList: [
    { prop: 'tableName', label: '表名', minWidth: '150' },
    { prop: 'tableComment', label: '表中文名', minWidth: '150' },
    { prop: 'menuUrl', label: '菜单路径', minWidth: '150' },
    { prop: 'isChild', label: '是否子表', minWidth: '60', slotName: 'isChild' },
    {
      prop: 'mainTableId',
      label: '主表名称',
      minWidth: '120',
      slotName: 'mainTableId'
    },
    {
      prop: 'isPublish',
      label: '是否发布',
      minWidth: '60',
      slotName: 'isPublish'
    },
    {
      prop: 'createdTime',
      label: '创建时间',
      minWidth: '120',
      slotName: 'createdTime'
    },
    {
      label: '操作',
      minWidth: '250',
      slotName: 'handler'
    }
  ]
}
